import withRequiredAuth from '../../HOC/withRequiredAuth';
import withRequiredProjects from '../../HOC/withRequiredProjects';
import Dashboard from './Dashboard';

export default withRequiredProjects(withRequiredAuth(Dashboard));
